module.exports = __webpack_public_path__ + "static/vue-vixens-4cc178bc74596c7f6b2ed5a29a6d57fa.png";